// import { useState, useRef, useEffect } from "react";
// import {
//   Col,
//   Row,
//   TableColumnsType,
//   Tag,
//   Button,
//   Space,
//   message,
//   Tooltip,
// } from "antd";
// import { PlusOutlined } from "@ant-design/icons";
// import { useHistory } from "react-router-dom";
// import {
//   EditOutlined,
//   DeleteOutlined,
//   EyeOutlined,
//   SendOutlined,
//   LoadingOutlined,
// } from "@ant-design/icons";
// import { BsTrash3 } from "react-icons/bs";
// import { GoPencil } from "react-icons/go";

// import "./jobEvaluation.less";
// import { paths } from "@router";
// import {
//   useDeleteJobEvaluationMutation,
//   useFetchAllJobEvaluationsQuery,
//   useJobEvaluationsSubmitMutation,
// } from "@services";
// import Table from "@components/Table";
// import AddJob from "./AddJob";
// import { IJobEvaluationDataResponse } from "@/store/jobEvaluation/types";
// import { dateFormat, JobEvaluationInquiryStatus } from "@/constants";
// import moment, { isMoment } from "moment";
// import { useTypedSelector } from "@/hooks";
// import {
//   handlePageChange,
//   handlePageSizeChange,
//   resetJobDetails,
// } from "@/store/jobEvaluation";
// import { useDispatch } from "react-redux";
// import CustomButton from "@/components/customButton";
// import SearchBox from "@/components/searchInput";
// import JobCreationModal from "@/components/JobCreationModal";
// import JobCreationTableComponent from "@components/jobCreationTable";
// import UploadMassJobs from "@components/UploadMassJobs";
// import { getTokenFromSharedStorage } from "@/services/cookies";
// import { checkPermission } from "@/utils";
// import {
//   CREATE_EVALUATION,
//   CREATE_JOB_EVALUATION,
//   DELETE_JOB_EVALUATION,
//   UPDATE_JOB_EVALUATION,
//   VIEW_JOB_EVALUATION,
// } from "@/router/permissions";
// import useDebounce from "@/hooks/useDebounce";

// const Jobs = () => {
//   const [deleteJobEvaluation] = useDeleteJobEvaluationMutation();
//   const history = useHistory();
//   const dispatch = useDispatch();
//   const [isVisible, setIsVisible] = useState(false);
//   const [loadingId, setLoadingId] = useState<number | null>(null);
//   const [isMassUpload, setIsMassUpload] = useState(false);
//   const [searchInput, setSearchInput] = useState("");
//   const debouncedSearch = useDebounce(searchInput, 500);
//   const { jobEvaluationListingPage, jobEvaluationPageSize } = useTypedSelector(
//     state => state?.jobEvaluation
//   );

//   const { user, permissions } = useTypedSelector(state => state.auth);
//   const company_id = user?.company?.id || 0;

//   const per = permissions.filter(data => data === "CREATE_JOB_EVALUATION");

//   const perUpdate =
//     permissions.includes("UPDATE_JOB_EVALUATION") ||
//     permissions.includes("all");

//   const perDelete = permissions.filter(
//     data => data === "DELETE_JOB_EVALUATION" || data === "all"
//   );
//   const {
//     data: jobEvaluationsData,
//     isLoading,
//     isFetching,
//     refetch,
//   } = useFetchAllJobEvaluationsQuery({
//     company_id,
//     page: jobEvaluationListingPage,
//     page_size: jobEvaluationPageSize,
//     search: debouncedSearch,
//   });

//   const data = jobEvaluationsData?.data;
//   const pagination = jobEvaluationsData?.pagination;
//   const [
//     jobEvaluationsSubmit,
//     { data: evaluationSubmitData, isLoading: isLoadingEvaluationSubmitData },
//   ] = useJobEvaluationsSubmitMutation();
//   const ref = useRef<HTMLDivElement>(null);

//   const debounceTimeoutForActionDelete = {
//     current: null as NodeJS.Timeout | null,
//   };
//   const handleSubmit = async (evaluationId: number) => {
//     try {
//       setLoadingId(evaluationId);
//       const result = await jobEvaluationsSubmit({
//         evaluationId,
//         company_id,
//       }).unwrap();
//       message.success("Job Evaluation Submited Successfully");
//       refetch();
//     } catch (error) {
//     } finally {
//       setLoadingId(null);
//     }
//   };

//   const debouncedApiCallDelete = (id: any, companyId: any, delay = 300) => {
//     if (debounceTimeoutForActionDelete.current) {
//       clearTimeout(debounceTimeoutForActionDelete.current); // Clear previous timeout
//     }

//     debounceTimeoutForActionDelete.current = setTimeout(async () => {
//       try {
//         await deleteJobEvaluation({
//           company_id: companyId,
//           job_evaluation_id: id,
//         }).unwrap();
//       } catch (error) {
//         console.error("Error:", error instanceof Error ? error.message : error);
//       }
//     }, delay);
//   };

//   const debounceTimeoutForActionUpdate = {
//     current: null as NodeJS.Timeout | null,
//   };

//   const debouncedApiCallUpdate = (id: any, companyId: any, delay = 300) => {
//     if (debounceTimeoutForActionUpdate.current) {
//       clearTimeout(debounceTimeoutForActionUpdate.current); // Clear previous timeout
//     }

//     debounceTimeoutForActionUpdate.current = setTimeout(async () => {
//       const token = getTokenFromSharedStorage();
//       try {
//         const response = await fetch(
//           `${process.env.REACT_APP_BASE_URL}/company/${companyId}/job-evaluations/${id}/`,
//           {
//             method: "PUT", // Update method
//             headers: {
//               Authorization: `Bearer ${token.access}`,
//               "Content-Type": "application/json",
//             },
//             body: JSON.stringify({ action: "update" }), // Adjust payload if needed
//           }
//         );

//         if (!response.ok) {
//           const errorData = await response.json();
//           return;
//         }

//         const data = await response.json();
//       } catch (error) {
//         console.error("Error:", error instanceof Error ? error.message : error);
//       }
//     }, delay);
//   };

//   const columns: TableColumnsType<IJobEvaluationDataResponse> = [
//     {
//       title: "Evaluation Id",
//       defaultSortOrder: "ascend",
//       dataIndex: "id",
//       key: "id",
//       // sorter: (a: any, b: any) => b?.id - a?.id,
//       align: "center",
//       render: (_, record, index) => record?.id,
//     },
//     {
//       title: "Date",
//       key: "updated_at",
//       dataIndex: "created_at",
//       sorter: (
//         a: IJobEvaluationDataResponse,
//         b: IJobEvaluationDataResponse
//       ) => {
//         return moment(a.updated_at).unix() - moment(b.updated_at).unix();
//       },

//       align: "center",
//       render: (record: any) => {
//         return (
//           <div className="text-wrap">
//             {`${moment(record).format("DD-MMM-YYYY")}`}
//           </div>
//         );
//       },
//     },
//     {
//       title: "Job Title",
//       dataIndex: "job_title",
//       key: "job_title",
//       align: "center",
//       sorter: (
//         a: IJobEvaluationDataResponse,
//         b: IJobEvaluationDataResponse
//       ) => {
//         return (a.job_title || "").localeCompare(b.job_title || "");
//       },
//     },
//     // {
//     //   title: "Job Function",
//     //   key: "job_function",
//     //   dataIndex: ["job_function", "name"],
//     //   sorter: (
//     //     a: IJobEvaluationDataResponse,
//     //     b: IJobEvaluationDataResponse
//     //   ) => {
//     //     const jobFunctionA = a.job_function?.name || "";
//     //     const jobFunctionB = b.job_function?.name || "";
//     //     return jobFunctionA.localeCompare(jobFunctionB);
//     //   },
//     // },
//     {
//       title: "Company Job Function",
//       dataIndex: "company_job_function_name",
//       key: "job_function_name",
//       align: "center",
//       width: 250,
//       sorter: (a, b) => {
//         return (a?.job_function_name || "").localeCompare(
//           b.job_function_name || ""
//         );
//       },
//     },
//     {
//       title: "Country",
//       dataIndex: "country_name",
//       key: "country_name",
//       align: "center",
//       sorter: (a, b) => {
//         return (a?.country_name || "").localeCompare(b?.country_name || "");
//       },
//     },
//     {
//       title: "Grade",
//       key: "evaluation_result",
//       width: 150,
//       align: "center",
//       sorter: (
//         a: IJobEvaluationDataResponse,
//         b: IJobEvaluationDataResponse
//       ) => {
//         const scoreA = a.evaluation_result || 0;
//         const scoreB = b.evaluation_result || 0;
//         return scoreA - scoreB;
//       },
//       // align: "center",
//       render: (record: IJobEvaluationDataResponse) => {
//         const score = record.evaluation_result ? record.evaluation_result : "-";
//         return <div className="text-wrap">{score}</div>;
//       },
//     },
//     {
//       title: "Actions",
//       key: "actions",
//       width: 90,
//       // align: "center",
//       align: "center",
//       render: (record: any) => {
//         const { id, company_id } = record;
//         const companyId = company_id;
//         const status = record?.status?.toLowerCase();

//         const showView =
//           status === JobEvaluationInquiryStatus.EVALUTAED ||
//           status === JobEvaluationInquiryStatus.CLOSE;

//         const showEdit =
//           checkPermission(UPDATE_JOB_EVALUATION) &&
//           (status === JobEvaluationInquiryStatus.OPEN ||
//             status === JobEvaluationInquiryStatus.EVALUTAED);

//         const showSubmit =
//           checkPermission(UPDATE_JOB_EVALUATION) &&
//           status === JobEvaluationInquiryStatus.EVALUTAED;

//         const showDelete = checkPermission(DELETE_JOB_EVALUATION);

//         const visibleButtons = [
//           showView,
//           showEdit,
//           showSubmit,
//           showDelete,
//         ].filter(Boolean).length;

//         const gridClass =
//           visibleButtons === 1
//             ? "grid-cols-1"
//             : visibleButtons === 2
//             ? "grid-cols-2"
//             : visibleButtons === 3
//             ? "grid-cols-3"
//             : "grid-cols-4";

//         return (
//           <div className="actions w-full">
//             <div className={`grid ${gridClass} gap-2 w-full`}>
//               {showView && (
//                 <Tooltip title="View">
//                   <Button
//                     className="w-full flex justify-center items-center rounded bg-bgView hover:bg-bgView"
//                     onClick={() =>
//                       history.push(
//                         paths.client.jobEvaluation.summary(id.toString())
//                       )
//                     }
//                   >
//                     <EyeOutlined style={{ color: "white", fontSize: "16px" }} />
//                   </Button>
//                 </Tooltip>
//               )}

//               {showEdit && (
//                 <Tooltip title="Edit">
//                   <Button
//                     className="w-full flex justify-center items-center rounded bg-bgEdit hover:bg-bgEdit"
//                     onClick={() =>
//                       history.push(
//                         paths.client.jobEvaluation.create(id.toString())
//                       )
//                     }
//                   >
//                     <GoPencil className="text-white text-sm" />
//                   </Button>
//                 </Tooltip>
//               )}

//               {showSubmit && (
//                 <Tooltip title="Submit for Approval">
//                   <Button
//                     className="w-full flex justify-center items-center rounded bg-bgShare hover:bg-bgShare"
//                     onClick={() => handleSubmit(id)}
//                   >
//                     {loadingId === id ? (
//                       <LoadingOutlined
//                         style={{ color: "white", fontSize: "16px" }}
//                       />
//                     ) : (
//                       <SendOutlined
//                         style={{ color: "white", fontSize: "16px" }}
//                       />
//                     )}
//                   </Button>
//                 </Tooltip>
//               )}

//               {showDelete && (
//                 <Tooltip title="Delete">
//                   <Button
//                     className="w-full flex justify-center items-center rounded bg-bgDelete hover:bg-bgDelete"
//                     onClick={() => debouncedApiCallDelete(id, companyId)}
//                   >
//                     <BsTrash3 className="text-white text-sm" />
//                   </Button>
//                 </Tooltip>
//               )}
//             </div>
//           </div>
//         );
//       },
//     },

//     // {
//     //   title: "Job Evaluation Status",
//     //   // dataIndex: "status",
//     //   key: "status",
//     //   align: "center",
//     //   align:"center",
//     // render: (record: IJobEvaluationDataResponse) => {
//     //     const color: { [key: string]: string } = {
//     //       open: "green",
//     //       "in progress": "gold",
//     //       close: "red",
//     //     };
//     //     const key = record.status?.key!;
//     //     return <Tag color={color[key.toLowerCase()]}>{key.toUpperCase()}</Tag>;
//     //   },
//     // },
//   ];

//   const onRowClick = (data: any) => {
//     const jobId = data?.id ? data?.id?.toString() : "";
//     data.status === JobEvaluationInquiryStatus.CLOSE
//       ? history.push(paths.client.jobEvaluation.summary(jobId))
//       : history.push(paths.client.jobEvaluation.create(jobId));
//   };
//   const onCloseModal = () => {
//     setIsVisible(false);
//   };
//   const onCloseMassModal = () => {
//     setIsMassUpload(false);
//   };
//   const handleTablePageChange = (page: number, pageSize?: number) => {
//     if (pageSize && pageSize !== jobEvaluationPageSize) {
//       dispatch(handlePageSizeChange(pageSize));
//     } else {
//       dispatch(handlePageChange(page));
//     }
//   };

//   useEffect(() => {
//     refetch();
//     if (ref.current) {
//       ref.current.scrollTop = 0;
//     }
//   }, []);

//   return (
//     <div
//       className="bg-white h-full p-4"
//       ref={ref}
//       // style={{ height: "400px", overflowY: "auto" }}
//       // style={{ height: "400px" }}
//     >
//       {/* <div className="appTitle text-base font-[500] mx-5">Job Creation</div> */}
//       <div className="jobCreationBar sticky top-0 z-10 bg-bgSidebar px-5 py-6 rounded-lg flex justify-between items-center mb-7">
//         <div className="title uppercase text-white font-semibold text-2xl">
//           Job Evaluation
//         </div>

//         <div className="flex items-center gap-x-4">
//           {(user?.role === "COMPANY_SUPER_USER" ||
//             user?.role === "TOM_MASTER_USER" ||
//             per.length > 0) && (
//             <>
//               <CustomButton
//                 onClick={() => {
//                   dispatch(resetJobDetails);
//                   setIsVisible(true);
//                 }}
//                 btnName="Evaluate Individual Job"
//                 customClasses="shadow-lg"
//               />

//               <CustomButton
//                 onClick={() => {
//                   dispatch(resetJobDetails);
//                   setIsMassUpload(true);
//                 }}
//                 btnName="Create Mass Upload"
//                 customClasses="shadow-lg "
//               />
//             </>
//           )}
//           <SearchBox
//             placeholder="Type to search..."
//             value={searchInput}
//             onChange={value => {
//               setSearchInput(value);
//               dispatch(handlePageChange(1));
//             }}
//           />
//         </div>
//       </div>

//       <div className="jobCreationListing bg-white py-6 rounded-lg">
//         <JobCreationTableComponent
//           onRowClick={onRowClick}
//           columns={columns}
//           data={data}
//           isLoading={isLoading || isFetching}
//           pagination={true}
//           count={pagination?.count}
//           onChangePage={handleTablePageChange}
//           page={jobEvaluationListingPage}
//           perUpdate={perUpdate}
//           perDelete={perDelete}
//           user={user?.role}
//           pageSize={jobEvaluationPageSize}
//         />

//         <JobCreationModal visible={isVisible} onClose={onCloseModal} />
//         <UploadMassJobs
//           refetchJobs={refetch}
//           visible={isMassUpload}
//           onClose={onCloseMassModal}
//         />
//       </div>
//     </div>
//   );
// };

// export default Jobs;

// v2
import { useState, useRef, useEffect } from "react";
import {
  Col,
  Row,
  TableColumnsType,
  Tag,
  Button,
  Space,
  message,
  Tooltip,
  Dropdown,
} from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import {
  EditOutlined,
  DeleteOutlined,
  EyeOutlined,
  SendOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import { BsTrash3 } from "react-icons/bs";
import { GoPencil } from "react-icons/go";
import { IoFilterSharp } from "react-icons/io5";

import "./jobEvaluation.less";
import { paths } from "@router";
import {
  useDeleteJobEvaluationMutation,
  useFetchAllJobEvaluationsQuery,
  useJobEvaluationsSubmitMutation,
} from "@services";
import Table from "@components/Table";
import AddJob from "./AddJob";
import { IJobEvaluationDataResponse } from "@/store/jobEvaluation/types";
import { dateFormat, JobEvaluationInquiryStatus } from "@/constants";
import moment, { isMoment } from "moment";
import { useTypedSelector } from "@/hooks";
import {
  handlePageChange,
  handlePageSizeChange,
  resetJobDetails,
} from "@/store/jobEvaluation";
import { useDispatch } from "react-redux";
import CustomButton from "@/components/customButton";
import SearchBox from "@/components/searchInput";
import JobCreationModal from "@/components/JobCreationModal";
import JobCreationTableComponent from "@components/jobCreationTable";
import UploadMassJobs from "@components/UploadMassJobs";
import { getTokenFromSharedStorage } from "@/services/cookies";
import { checkPermission } from "@/utils";
import {
  CREATE_EVALUATION,
  CREATE_JOB_EVALUATION,
  DELETE_JOB_EVALUATION,
  UPDATE_JOB_EVALUATION,
  VIEW_JOB_EVALUATION,
} from "@/router/permissions";
import useDebounce from "@/hooks/useDebounce";

const Jobs = () => {
  const [deleteJobEvaluation] = useDeleteJobEvaluationMutation();
  const history = useHistory();
  const dispatch = useDispatch();
  const [isVisible, setIsVisible] = useState(false);
  const [loadingId, setLoadingId] = useState<number | null>(null);
  const [isMassUpload, setIsMassUpload] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const debouncedSearch = useDebounce(searchInput, 500);
  const { jobEvaluationListingPage, jobEvaluationPageSize } = useTypedSelector(
    state => state?.jobEvaluation
  );

  const { user, permissions } = useTypedSelector(state => state.auth);
  const company_id = user?.company?.id || 0;

  const per = permissions.filter(data => data === "CREATE_JOB_EVALUATION");

  const perUpdate =
    permissions.includes("UPDATE_JOB_EVALUATION") ||
    permissions.includes("all");

  const perDelete = permissions.filter(
    data => data === "DELETE_JOB_EVALUATION" || data === "all"
  );
  const {
    data: jobEvaluationsData,
    isLoading,
    isFetching,
    refetch,
  } = useFetchAllJobEvaluationsQuery({
    company_id,
    page: jobEvaluationListingPage,
    page_size: jobEvaluationPageSize,
    search: debouncedSearch,
  });

  const data = jobEvaluationsData?.data;
  const pagination = jobEvaluationsData?.pagination;
  const [
    jobEvaluationsSubmit,
    { data: evaluationSubmitData, isLoading: isLoadingEvaluationSubmitData },
  ] = useJobEvaluationsSubmitMutation();
  const ref = useRef<HTMLDivElement>(null);

  const debounceTimeoutForActionDelete = {
    current: null as NodeJS.Timeout | null,
  };
  const handleSubmit = async (evaluationId: number) => {
    try {
      setLoadingId(evaluationId);
      const result = await jobEvaluationsSubmit({
        evaluationId,
        company_id,
      }).unwrap();
      message.success("Job Evaluation Submited Successfully");
      refetch();
    } catch (error) {
    } finally {
      setLoadingId(null);
    }
  };

  const debouncedApiCallDelete = (id: any, companyId: any, delay = 300) => {
    if (debounceTimeoutForActionDelete.current) {
      clearTimeout(debounceTimeoutForActionDelete.current); // Clear previous timeout
    }

    debounceTimeoutForActionDelete.current = setTimeout(async () => {
      try {
        await deleteJobEvaluation({
          company_id: companyId,
          job_evaluation_id: id,
        }).unwrap();
      } catch (error) {
        console.error("Error:", error instanceof Error ? error.message : error);
      }
    }, delay);
  };

  const debounceTimeoutForActionUpdate = {
    current: null as NodeJS.Timeout | null,
  };

  const debouncedApiCallUpdate = (id: any, companyId: any, delay = 300) => {
    if (debounceTimeoutForActionUpdate.current) {
      clearTimeout(debounceTimeoutForActionUpdate.current); // Clear previous timeout
    }

    debounceTimeoutForActionUpdate.current = setTimeout(async () => {
      const token = getTokenFromSharedStorage();
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/company/${companyId}/job-evaluations/${id}/`,
          {
            method: "PUT", // Update method
            headers: {
              Authorization: `Bearer ${token.access}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ action: "update" }), // Adjust payload if needed
          }
        );

        if (!response.ok) {
          const errorData = await response.json();
          return;
        }

        const data = await response.json();
      } catch (error) {
        console.error("Error:", error instanceof Error ? error.message : error);
      }
    }, delay);
  };

  const columns: TableColumnsType<IJobEvaluationDataResponse> = [
    {
      title: "Evaluation Id",
      defaultSortOrder: "ascend",
      dataIndex: "id",
      key: "id",
      width: 150,
      // sorter: (a: any, b: any) => b?.id - a?.id,
      align: "center",
      render: (_, record, index) => record?.id,
    },
    {
      title: "Date",
      key: "updated_at",
      dataIndex: "created_at",
      sorter: (
        a: IJobEvaluationDataResponse,
        b: IJobEvaluationDataResponse
      ) => {
        return moment(a.updated_at).unix() - moment(b.updated_at).unix();
      },

      align: "center",
      render: (record: any) => {
        return (
          <div className="text-wrap">
            {`${moment(record).format("DD-MMM-YYYY")}`}
          </div>
        );
      },
    },
    {
      title: "Job Title",
      dataIndex: "job_title",
      key: "job_title",
      align: "center",
      width: 280,
      sorter: (
        a: IJobEvaluationDataResponse,
        b: IJobEvaluationDataResponse
      ) => {
        return (a.job_title || "").localeCompare(b.job_title || "");
      },
    },
    // {
    //   title: "Job Function",
    //   key: "job_function",
    //   dataIndex: ["job_function", "name"],
    //   sorter: (
    //     a: IJobEvaluationDataResponse,
    //     b: IJobEvaluationDataResponse
    //   ) => {
    //     const jobFunctionA = a.job_function?.name || "";
    //     const jobFunctionB = b.job_function?.name || "";
    //     return jobFunctionA.localeCompare(jobFunctionB);
    //   },
    // },
    {
      title: "Company Job Function",
      dataIndex: "company_job_function_name",
      key: "job_function_name",
      align: "center",
      width: 250,
      sorter: (a, b) => {
        return (a?.job_function_name || "").localeCompare(
          b.job_function_name || ""
        );
      },
    },
    {
      title: "Country",
      dataIndex: "country_name",
      key: "country_name",
      align: "center",
      sorter: (a, b) => {
        return (a?.country_name || "").localeCompare(b?.country_name || "");
      },
    },
    {
      title: "Grade",
      key: "evaluation_result",
      width: 150,
      align: "center",
      sorter: (
        a: IJobEvaluationDataResponse,
        b: IJobEvaluationDataResponse
      ) => {
        const scoreA = a.evaluation_result || 0;
        const scoreB = b.evaluation_result || 0;
        return scoreA - scoreB;
      },
      // align: "center",
      render: (record: IJobEvaluationDataResponse) => {
        const score = record.evaluation_result ? record.evaluation_result : "-";
        return <div className="text-wrap">{score}</div>;
      },
    },
    {
      title: "Actions",
      key: "actions",
      // width: 190,
      align: "center",
      render: (record: any) => {
        const { id, company_id } = record;
        const companyId = company_id;
        const status = record?.status?.toLowerCase();

        const showView =
          status === JobEvaluationInquiryStatus.EVALUTAED ||
          status === JobEvaluationInquiryStatus.CLOSE;

        const showEdit =
          checkPermission(UPDATE_JOB_EVALUATION) &&
          (status === JobEvaluationInquiryStatus.OPEN ||
            status === JobEvaluationInquiryStatus.EVALUTAED);

        const showSubmit =
          checkPermission(UPDATE_JOB_EVALUATION) &&
          status === JobEvaluationInquiryStatus.EVALUTAED;

        const showDelete = checkPermission(DELETE_JOB_EVALUATION);

        const visibleButtons = [
          showView,
          showEdit,
          showSubmit,
          showDelete,
        ].filter(Boolean).length;

        const gridClass =
          visibleButtons === 1
            ? "grid-cols-1"
            : visibleButtons === 2
            ? "grid-cols-2"
            : visibleButtons === 3
            ? "grid-cols-3"
            : "grid-cols-4";

        const buttonClass =
          "w-full min-w-0 h-8 p-0 flex justify-center items-center rounded";

        const iconStyle = {
          color: "white",
          fontSize: "16px",
          flexShrink: 0,
        };

        return (
          <div className="actions w-full">
            <div className={`grid ${gridClass} gap-2 w-full`}>
              {showView && (
                <Tooltip title="View">
                  <Button
                    className={`${buttonClass} bg-bgView hover:bg-bgView`}
                    onClick={() =>
                      history.push(
                        paths.client.jobEvaluation.summary(id.toString())
                      )
                    }
                  >
                    <EyeOutlined style={iconStyle} />
                  </Button>
                </Tooltip>
              )}

              {showEdit && (
                <Tooltip title="Edit">
                  <Button
                    className={`${buttonClass} bg-bgEdit hover:bg-bgEdit`}
                    onClick={() =>
                      history.push(
                        paths.client.jobEvaluation.create(id.toString())
                      )
                    }
                  >
                    <GoPencil className="text-white text-base flex-shrink-0" />
                  </Button>
                </Tooltip>
              )}

              {showSubmit && (
                <Tooltip title="Submit for Approval">
                  <Button
                    className={`${buttonClass} bg-bgShare hover:bg-bgShare`}
                    onClick={() => handleSubmit(id)}
                  >
                    {loadingId === id ? (
                      <LoadingOutlined style={iconStyle} />
                    ) : (
                      <SendOutlined style={iconStyle} />
                    )}
                  </Button>
                </Tooltip>
              )}

              {showDelete && (
                <Tooltip title="Delete">
                  <Button
                    className={`${buttonClass} bg-bgDelete hover:bg-bgDelete`}
                    onClick={() => debouncedApiCallDelete(id, companyId)}
                  >
                    <BsTrash3 className="text-white text-base flex-shrink-0" />
                  </Button>
                </Tooltip>
              )}
            </div>
          </div>
        );
      },
    },

    // {
    //   title: "Job Evaluation Status",
    //   // dataIndex: "status",
    //   key: "status",
    //   align: "center",
    //   align:"center",
    // render: (record: IJobEvaluationDataResponse) => {
    //     const color: { [key: string]: string } = {
    //       open: "green",
    //       "in progress": "gold",
    //       close: "red",
    //     };
    //     const key = record.status?.key!;
    //     return <Tag color={color[key.toLowerCase()]}>{key.toUpperCase()}</Tag>;
    //   },
    // },
  ];

  const [visibleColumnKeys, setVisibleColumnKeys] = useState<string[]>(() =>
    columns
      .map(column => column.key)
      .filter((key): key is string => typeof key === "string")
  );

  const filteredColumns = columns.filter(
    column =>
      typeof column.key === "string" && visibleColumnKeys.includes(column.key)
  );

  const columnOverlay = (
    <div
      style={{
        background: "#fff",
        padding: 8,
        borderRadius: 6,
        boxShadow: "0 3px 10px rgba(0,0,0,0.15)",
        minWidth: 240,
        maxHeight: 300,
        overflowY: "auto",
      }}
      onClick={event => event.stopPropagation()}
    >
      {columns.map(column => {
        const columnKey =
          typeof column.key === "string" ? column.key : undefined;

        if (!columnKey) return null;

        const isActionsColumn = columnKey === "actions";
        const isChecked = visibleColumnKeys.includes(columnKey);
        const isDisabled =
          isActionsColumn || (isChecked && visibleColumnKeys.length <= 3);

        return (
          <label
            key={columnKey}
            style={{
              display: isDisabled ? "none" : "flex",
              alignItems: "center",
              gap: 12,
              padding: "6px 8px",
              borderRadius: 4,
              cursor: isDisabled ? "not-allowed" : "pointer",
              opacity: isDisabled ? 0.6 : 1,
            }}
          >
            <input
              type="checkbox"
              checked={isChecked}
              disabled={isDisabled}
              onChange={() => {
                if (isActionsColumn) return;

                setVisibleColumnKeys(previousKeys =>
                  isChecked
                    ? previousKeys.filter(key => key !== columnKey)
                    : [...previousKeys, columnKey]
                );
              }}
              style={{
                margin: 0,
                width: 16,
                height: 16,
                flexShrink: 0,
              }}
            />

            <span
              style={{
                flex: 1,
                fontSize: 14,
                lineHeight: "18px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {typeof column.title === "string"
                ? column.title.replace(/\b\w/g, character =>
                    character.toUpperCase()
                  )
                : column.title}
            </span>
          </label>
        );
      })}
    </div>
  );

  const onRowClick = (data: any) => {
    const jobId = data?.id ? data?.id?.toString() : "";
    data.status === JobEvaluationInquiryStatus.CLOSE
      ? history.push(paths.client.jobEvaluation.summary(jobId))
      : history.push(paths.client.jobEvaluation.create(jobId));
  };
  const onCloseModal = () => {
    setIsVisible(false);
  };
  const onCloseMassModal = () => {
    setIsMassUpload(false);
  };
  const handleTablePageChange = (page: number, pageSize?: number) => {
    if (pageSize && pageSize !== jobEvaluationPageSize) {
      dispatch(handlePageSizeChange(pageSize));
    } else {
      dispatch(handlePageChange(page));
    }
  };

  useEffect(() => {
    refetch();
    if (ref.current) {
      ref.current.scrollTop = 0;
    }
  }, []);

  return (
    <div
      className="bg-white h-full p-4"
      ref={ref}
      // style={{ height: "400px", overflowY: "auto" }}
      // style={{ height: "400px" }}
    >
      {/* <div className="appTitle text-base font-[500] mx-5">Job Creation</div> */}
      <div className="jobCreationBar sticky top-0 z-10 bg-bgSidebar px-5 py-6 rounded-lg flex justify-between items-center mb-7">
        <div className="title uppercase text-white font-semibold text-2xl">
          Job Evaluation
        </div>

        <div className="flex items-center gap-x-4">
          {(user?.role === "COMPANY_SUPER_USER" ||
            user?.role === "TOM_MASTER_USER" ||
            per.length > 0) && (
            <>
              <CustomButton
                onClick={() => {
                  dispatch(resetJobDetails);
                  setIsVisible(true);
                }}
                btnName="Evaluate Individual Job"
                customClasses="shadow-lg"
              />

              <CustomButton
                onClick={() => {
                  dispatch(resetJobDetails);
                  setIsMassUpload(true);
                }}
                btnName="Create Mass Upload"
                customClasses="shadow-lg "
              />
            </>
          )}
          <SearchBox
            placeholder="Type to search..."
            value={searchInput}
            onChange={value => {
              setSearchInput(value);
              dispatch(handlePageChange(1));
            }}
          />

          <Dropdown
            overlay={columnOverlay}
            trigger={["click"]}
            placement="bottomLeft"
          >
            <div>
              <CustomButton
                btnName="Column Filter"
                customClasses="shadow-lg"
                icon={<IoFilterSharp />}
              ></CustomButton>
            </div>
          </Dropdown>
        </div>
      </div>

      <div className="jobCreationListing bg-white py-4 rounded-lg">
        <JobCreationTableComponent
          onRowClick={onRowClick}
          columns={filteredColumns}
          data={data}
          isLoading={isLoading || isFetching}
          pagination={true}
          count={pagination?.count}
          onChangePage={handleTablePageChange}
          page={jobEvaluationListingPage}
          perUpdate={perUpdate}
          perDelete={perDelete}
          user={user?.role}
          pageSize={jobEvaluationPageSize}
        />

        <JobCreationModal visible={isVisible} onClose={onCloseModal} />
        <UploadMassJobs
          refetchJobs={refetch}
          visible={isMassUpload}
          onClose={onCloseMassModal}
        />
      </div>
    </div>
  );
};

export default Jobs;
